/**
 * @file 保存済検索条件リストの取得完了を監視する
 */
'use strict'

import ApplyClass from "../../Utils/ApplyClass"
import BtnDeleteFilter from "./BtnDeleteFilter"

/**
 * @classname GetSavedFiltersListener
 * @classdesc 保存済検索条件リストの取得完了を監視する
 */
export default class GetSavedFiltersListener {
	/**
	 * @constructor
	 */
	constructor(controller) {
		console.log(`${this.constructor.name}.constructor`)
		this._controller = controller
		this._savedFiltersModal = document.getElementById('modal-saved-filters')
		this._SavedFiltersModal = bootstrap.Modal.getInstance(this._savedFiltersModal)
		this._controller.on('getSavedFiltersComplete', () => this.onGetSavedFiltersComplete())
	}


	/**
	 * 保存済検索条件リストの取得完了時のコールバック
	 *
	 * @memberof SaveFilter
	 */
	onGetSavedFiltersComplete() {
		console.log(`${this.constructor.name}.onGetSavedFiltersComplete`)
		let listItems = ''
		this._controller._filters.forEach(filter => listItems += `
			<li class="p-2 bg-light list-item">
				<div class="d-flex align-items-center border-bottom pb-2">
					<p class="flex-grow-1 fwb text">${filter.title}</p>
					<div class="d-flex">
						<button class="mr-2 btn btn-danger btn-sm btn-delete-filter" data-filter-id="${filter.id}" type="button">削除</button>
						<a class="btn btn-primary btn-sm" href="${filter.href}">検索</a>
					</div>
				</div>
				<p class="pt-2 fs12 text">${filter.condition}</p>
			</li>`
		)
		$('#modal-saved-filters').find('.list-saved-filters').html(listItems)
		$(this._savedFiltersModal).find('.btn-delete-filter').each((idx, e) => {
			const _$e = $(e)
			ApplyClass.apply(BtnDeleteFilter, _$e, [_$e, this._controller])
		})
	}
}
